/**
 * HierarchicalRouteDispatcher.mjs
 *
 * Route-level orchestration layer for the /:categorySlug/* splat route.
 * Checks React Router's location.state to determine whether to render
 * TopicPage or UnifiedArticleDetailPage, avoiding unnecessary TopicPage
 * mounting (and its hooks/effects/fetches) for known article navigations.
 *
 * Delegation logic:
 *   state.type === 'article'  →  UnifiedArticleDetailPage (zero TopicPage overhead)
 *   everything else           →  TopicPage (retains full topic + article safety nets)
 */
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import TopicPage from '../pages/TopicPage.mjs';
import UnifiedArticleDetailPage from '../pages/UnifiedArticleDetailPage.mjs';

const HierarchicalRouteDispatcher = () => {
    const location = useLocation();
    const { '*': splatPath } = useParams();

    if (location.state?.type === 'article') {
        // Extract the article slug from the splat path.
        // Under /:categorySlug/*, the splat contains everything after the category,
        // e.g. 'ncaa-basketball/article-slug' → last segment is the article slug.
        const segments = (splatPath || '').split('/').filter(Boolean);
        const articleSlug = segments[segments.length - 1];

        return <UnifiedArticleDetailPage slugOverride={articleSlug} />;
    }

    return <TopicPage />;
};

export default HierarchicalRouteDispatcher;
